namespace GeniuzPOS.Administration {
    export namespace UnlockUserService {
        export const baseUrl = 'Administration/UnlockUserService';

        export declare function PosUnlockUser(request: UnlockUserRequest, onSuccess?: (response: UnlockUserResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            PosUnlockUser = "Administration/UnlockUserService/PosUnlockUser"
        }

        [
            'PosUnlockUser'
        ].forEach(x => {
            (<any>UnlockUserService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
